import { updateGeo } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { removeDistrictFromJsonQuery } from 'shared/utils/jsonQuery';
import { selectSelectedDistricts } from 'shared/selectors/geo';
import { setSelectedDistricts } from 'shared/slices/geo';

export const removeDistrict =
  (id: number): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);

    const newGeo = removeDistrictFromJsonQuery(jsonQuery, id);

    const selectedDistricts = selectSelectedDistricts(state);
    const newSelectedDistricts = selectedDistricts.filter(value => value.id !== id);

    dispatch(setSelectedDistricts(newSelectedDistricts));
    dispatch(updateGeo(newGeo));
    dispatch(updateSearchMeta());
  };
